// extracted by mini-css-extract-plugin
module.exports = {"book":"BookHolder_book__3POcc","bookNoSide":"BookHolder_bookNoSide__iIk6Y"};